import { Card, CardContent } from "@/components/ui/card";
import { QuoteForm } from "@/components/QuoteForm";
import { Phone, Mail, Clock, MapPin, ShieldCheck, Award, CheckCircle2 } from "lucide-react";

export default function QuotePage() {
  return (
    <div data-testid="quote-page">
      {/* Hero Section */}
      <section className="bg-[#0F172A] py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="inline-block text-[#F59E0B] font-medium text-sm uppercase tracking-wider mb-4">
            Free Quote
          </span>
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white uppercase mb-6">
            Request a Quote
          </h1>
          <p className="text-slate-300 max-w-2xl mx-auto text-lg">
            Fill out the form below and our team will provide you with a detailed quote
            within 24-48 business hours.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 lg:py-24 bg-[#F1F5F9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-12">
            {/* Form */}
            <div className="lg:col-span-2">
              <Card className="border-0 shadow-lg">
                <CardContent className="p-8 lg:p-10">
                  <h2 className="font-heading text-2xl font-bold text-[#0F172A] uppercase mb-8">
                    Project Details
                  </h2>
                  <QuoteForm />
                </CardContent>
              </Card>
            </div>

            {/* Sidebar */}
            <div className="space-y-6">
              {/* Why Choose Us */}
              <Card className="border-0 shadow-lg bg-[#0F172A] text-white">
                <CardContent className="p-8">
                  <h3 className="font-heading text-xl font-bold uppercase mb-6">
                    Why Choose Gap Pro?
                  </h3>
                  <ul className="space-y-4">
                    <li className="flex items-start gap-3">
                      <ShieldCheck className="w-5 h-5 text-[#F59E0B] flex-shrink-0 mt-0.5" />
                      <div>
                        <p className="font-medium">Fire Rated Certified</p>
                        <p className="text-slate-400 text-sm">Full compliance documentation</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <Award className="w-5 h-5 text-[#F59E0B] flex-shrink-0 mt-0.5" />
                      <div>
                        <p className="font-medium">15+ Years Experience</p>
                        <p className="text-slate-400 text-sm">Trusted by top builders</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <CheckCircle2 className="w-5 h-5 text-[#F59E0B] flex-shrink-0 mt-0.5" />
                      <div>
                        <p className="font-medium">Quality Guaranteed</p>
                        <p className="text-slate-400 text-sm">Professional workmanship</p>
                      </div>
                    </li>
                  </ul>
                </CardContent>
              </Card>

              {/* Contact Info */}
              <Card className="border-0 shadow-lg">
                <CardContent className="p-8">
                  <h3 className="font-heading text-xl font-bold text-[#0F172A] uppercase mb-6">
                    Contact Us Directly
                  </h3>
                  <ul className="space-y-4">
                    <li>
                      <a href="tel:+61435825379" className="flex items-center gap-3 text-slate-600 hover:text-[#F59E0B] transition-colors">
                        <Phone className="w-5 h-5 text-[#F59E0B]" />
                        <span>0435 825 379</span>
                      </a>
                    </li>
                    <li>
                      <a href="mailto:danny@gappro.com.au" className="flex items-center gap-3 text-slate-600 hover:text-[#F59E0B] transition-colors">
                        <Mail className="w-5 h-5 text-[#F59E0B]" />
                        <span>danny@gappro.com.au</span>
                      </a>
                    </li>
                    <li className="flex items-center gap-3 text-slate-600">
                      <MapPin className="w-5 h-5 text-[#F59E0B]" />
                      <span>Gold Coast, QLD</span>
                    </li>
                    <li className="flex items-start gap-3 text-slate-600">
                      <Clock className="w-5 h-5 text-[#F59E0B] flex-shrink-0 mt-0.5" />
                      <div>
                        <p>Mon - Fri: 6:30am - 5pm</p>
                      </div>
                    </li>
                  </ul>
                </CardContent>
              </Card>

              {/* Service Areas */}
              <Card className="border-0 shadow-lg">
                <CardContent className="p-8">
                  <h3 className="font-heading text-xl font-bold text-[#0F172A] uppercase mb-6">
                    Service Areas
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {[
                      "Surfers Paradise",
                      "Broadbeach",
                      "Southport",
                      "Main Beach",
                      "Robina",
                      "Coolangatta",
                      "Tweed Heads",
                      "Brisbane South",
                    ].map((area) => (
                      <span
                        key={area}
                        className="px-3 py-1 bg-[#F1F5F9] text-slate-600 text-sm rounded-full"
                      >
                        {area}
                      </span>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
